<template>
  <div>
    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="alert alert-secondary"
      role="alert"
    >
      <p v-bind:class="{ fontWeightBold: !notification.seen }">
        {{ notification.text }}
      </p>

      <span>{{ notification.createdDate | formatDate }}</span>
    </div>
    <span v-if="notifications.length === 0">{{
      $t("NavBar.NoNotifications")
    }}</span>
    <div>
      <BackButton />
    </div>
  </div>
</template>

<script>
import NotificationService from "../services/NotificationService";
import BackButton from "../components/common/BackButton";

export default {
  name: "Notifications",
  notificationService: null,
  components: { BackButton },
  data() {
    return {
      notifications: [],
    };
  },
  created() {
    this.notificationService = new NotificationService();
  },
  mounted() {
    this.notificationService.getNotifications().then((response) => {
      this.notifications = response.data;
      const notificationIds = this.notifications
        .filter((s) => !s.seen)
        .map((s) => s.id);
      if (notificationIds)
        this.notificationService.seenNotifications(notificationIds);
    });
  },
  back() {
    return this.$router.push({ name: "work-days" });
  },
};
</script>
<style scoped>
.fontWeightBold {
  font-weight: bold;
}
</style>
